(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fiorisci-contact-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var dialog = document.getElementById('fiorisci-contact-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }
  function openModal() {
    if (!dialog.open) {
      dialog.showModal();
      lockScroll(true);
      var first = dialog.querySelector('input, textarea, button.fiorisci-cmodal__close');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
  }
  function closeModal() { if (dialog.open) dialog.close(); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fiorisci-contact-open]')) { e.preventDefault(); openModal(); }
    else if (e.target.closest('[data-fiorisci-contact-close]')) { e.preventDefault(); closeModal(); }
  });

  // click outside the card (on the backdrop) closes
  dialog.addEventListener('click', function (e) {
    var card = dialog.querySelector('.fiorisci-cmodal__card');
    if (!card) return;
    var r = card.getBoundingClientRect();
    var outside = e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    if (outside) closeModal();
  });

  // restore scroll on any close (button, backdrop, ESC)
  dialog.addEventListener('close', function () { lockScroll(false); });

  // reopen after a contact POST so the success/error message is visible
  if (dialog.querySelector('.fiorisci-cform__success, .fiorisci-cform__errors')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openModal);
    } else {
      openModal();
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
